module.exports = __webpack_public_path__ + "static/get-inspired-985c6ca72044423d43d3c9701e30b8d7.png";